import React, { ReactChildren, useState } from 'react';
import { Tooltip, withStyles } from '@material-ui/core';
import { Icon, Box } from 'bloomer';
import styled from 'styled-components';
import { TooltipProps } from '@material-ui/core/Tooltip';
import { Color } from 'csstype';

const ICON_SIZE = '20px';
const StyledIcon = styled(Icon)<any>`
  color: white;
  background: grey;
  border-radius: 50%;
  width: ${ICON_SIZE};
  height: ${ICON_SIZE};
  line-height: ${ICON_SIZE};
  display: block;
  text-align: center;
`;

const Popper = styled(Box)<any>`
  position: relative;
`;

function arrowGenerator(direction: 'top' | 'bottom' | 'left' | 'right', color: Color) {
  switch (direction) {
    case 'left':
      return `
        right: 0;
        marginRight: -0.95em;
        height: 2em;
        width: 1em;
        &:before {
          left: calc(100% + 1px);
          border-width: 11px;
          border-color: transparent transparent transparent rgb(220, 220, 220);
        }
        &:after {
          border-width: 10px;
          border-color: transparent transparent transparent white;
        }
      `;

    default:
      break;
  }
  // return {
  //   '&[x-placement*="bottom"] $arrow': {
  //     top: 0,
  //     left: 0,
  //     marginTop: '-0.95em',
  //     width: '2em',
  //     height: '1em',
  //     '&::before': {
  //       borderWidth: '0 1em 1em 1em',
  //       borderColor: `transparent transparent ${color} transparent`,
  //     },
  //   },
  //   '&[x-placement*="top"] $arrow': {
  //     bottom: 0,
  //     left: 0,
  //     marginBottom: '-0.95em',
  //     width: '2em',
  //     height: '1em',
  //     '&::before': {
  //       borderWidth: '1em 1em 0 1em',
  //       borderColor: `${color} transparent transparent transparent`,
  //     },
  //   },
  //   '&[x-placement*="right"] $arrow': {
  //     left: 0,
  //     marginLeft: '-0.95em',
  //     height: '2em',
  //     width: '1em',
  //     '&::before': {
  //       borderWidth: '1em 1em 1em 0',
  //       borderColor: `transparent ${color} transparent transparent`,
  //     },
  //   },
  // };
}

const StyledTooltip = withStyles(
  () =>
    ({
      tooltip: {
        background: 'none',
        padding: 0,
      },
    } as any),
)(Tooltip);

const Arrow = styled.span<any>`
  position: absolute;
  font-size: 6px;
  &:before,
  &:after {
    content: '';
    position: absolute;
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
  ${({ direction }) => arrowGenerator(direction, 'white')}
`;

export const InfoTooltip = ({
  children,
  isOpen,
  zIndex,
  ...props
}: {
  children: ReactChildren | string | JSX.Element[] | JSX.Element;
  isOpen?: boolean;
  zIndex: number;
} & Partial<TooltipProps>) => {
  const [arrowRef, setArrowRef] = useState<HTMLSpanElement | null>(null);
  const styles = { style: { zIndex: zIndex } };
  return (
    <StyledTooltip
      open={isOpen}
      PopperProps={{
        ...(zIndex && styles),
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      title={
        <Popper>
          <>{children}</>
          <Arrow ref={setArrowRef} direction="left" />
        </Popper>
      }
      placement="left"
      {...props}
    >
      <span className="icon-tooltip">
        <StyledIcon className="fa fa-info" />
      </span>
    </StyledTooltip>
  );
};

export default InfoTooltip;
